/** Dispatched on window when the header's fullscreen button is clicked; Calendar.tsx listens and opens its overlay. */
export const CALENDAR_FULLSCREEN_EVENT = "calendar-open-fullscreen";
